<template>
	<div>
		<el-row>
			<el-col :span="8"><span>请支付:</span></el-col>
			<el-col :span="8" @click.native="payByAli()">
				<el-image :src="aliImg" style="max-width: 50px;float: left;">
				</el-image>
			</el-col>
			<el-col :span="8" @click.native="payByWX()">
				<el-image :src="wxImg" style="max-width: 50px;float: left;">
				</el-image>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import pay from '../../apifunction/OnlinePay.js'
	import member from '../../apifunction/Member.js'
	export default {
		created() {
			this.IsPaySuccess()
			
		},
		data(){
			return {
				aliImg:'/img/PayImg/ali.png',
				wxImg:'/img/PayImg/wx.png',
				OrderID:this.inOrderID,
				OrderDesc:this.inOrderDesc,
				Amount:this.inAmount,
				ispayok:false
			}
		},
		inject:['payok'],
		props:['inOrderID','inOrderDesc','inAmount'],
		methods:{
			payByAli()
			{
				if(this.inAmount<=0)
				return;
				let userent = this.$myglobal.getUserInfo();
				pay.PayMOrderByAli(userent.mobile,this.OrderID,this.OrderDesc,this.inAmount)
				.then(res => {
					let ent = JSON.parse(JSON.stringify(res.data))
					if (ent.Flag == 'success') {
						this.doHtml(ent.Data);
						// this.IsPaySuccess();
					} else
						this.$message.info(ent.Msg);
				})
			},
			payByWX(){
				alert('wx')
			},
			IsPaySuccess(){
				pay.QueryByAli(this.inOrderID)
				.then(res => {
					let ent = JSON.parse(JSON.stringify(res.data))
					if (ent.Flag == 'success') {
						this.payok();
						this.dopay();
					} 
				})
			},
			dopay(){
				let userent = this.$myglobal.getUserInfo();
				member.PayShopOrder(userent.mobile,this.inOrderID)
				.then(res => {
					let ent = JSON.parse(JSON.stringify(res.data))
					if (ent.Flag == 'success') {
						}
						});
			},
			doHtml(formhtml)
			{
				let divForm = document.getElementsByTagName('divform')
				 if (divForm.length) {
				     document.body.removeChild(divForm[0])
				   }
				   const div = document.createElement('divform')
				   div.innerHTML = formhtml // res.data就是sb支付宝返回给你的form
				   document.body.appendChild(div)
				   // document.forms[0].setAttribute('target', '_blank') // 加了_blank可能出问题所以我注释了
				   document.forms[0].submit();
			}
		}
		}
</script>

<style>
</style>
